const shadows = {
    card: '0px 4px 4px rgba(0, 0, 0, 0.2)'
}

export default shadows